module.exports = __webpack_public_path__ + "static/media/um6pLogo.f375c9c7.jpg";